<template>
  <graph-detail06-template
    :com-group-list="comGroupList"
    :board-ids="[107]"
    field-code="public-transportation"
    graph1-title="전체 (공중교통수단)안전·보건 교육 현황"
    graph2-title="월별 (공중교통수단)안전·보건 교육 현황"
    graph3-title="기간별 (공중교통수단)안전·보건 교육 현황"
  />
</template>

<script>
/* eslint-disable brace-style */
import GraphDetail06Template from "@/views/graph-detail/GraphDetail06Template.vue";

export default {
  name: "GraphDetail80",
  components: {
    GraphDetail06Template,
  },
  props: {
    comGroupList: Object,
  },
};
</script>

<style scoped></style>
